import { render } from "./old-book-form.vue?vue&type=template&id=1ecbdc4d&scoped=true"
import script from "./old-book-form.js?vue&type=script&lang=js&external"
export * from "./old-book-form.js?vue&type=script&lang=js&external"

import "./old-book-form.css?vue&type=style&index=0&id=1ecbdc4d&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecbdc4d"]])

export default __exports__